export default __webpack_public_path__ + "static/media/babatunde.d7e5b158.png";